import React, { useState, useEffect } from 'react';
import Copyright from '../Element/Copyright'
import Header from '../Element/Header'
import axios from 'axios'
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import onSubmit from './OnSubmit'
import { useHistory } from 'react-router-dom';
import { Divider } from '@material-ui/core';
import Swal from 'sweetalert2'



const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  large: {
    width: theme.spacing(10),
    height: theme.spacing(10),
  },
}));

export default function Register() {
  const history = useHistory();
  const classes = useStyles();
  const [fullname, setFullname] = useState('')
  const [email, setEmail] = useState('')
  const [phonenumber, setPhonenumber] = useState('')
  const [zoom, setZoom] = useState('')
  const [type, setType] = useState('')
  const [event, setEvent] = useState('')
  const [typeParticipant, setTypeParticipant] = useState([])

  useEffect(() => {
    const event = async () => {
      const result = await axios(
        `${process.env.REACT_APP_API}/participant/event/type/`,
      );
      window.localStorage.setItem('event', JSON.stringify(result.data));
      setEvent(result.data);
    };
    const fetchData = async () => {
      const result = await axios(
        `${process.env.REACT_APP_API}/admin/participant/type`,
      );

      setTypeParticipant(result.data);
    };

    event();
    fetchData();
  }, []);

  const handleChange = (event) => {
    setType(event.target.value);
  };

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div>
        <Header />
        <form noValidate className={classes.form}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                required
                fullWidth
                id="fullname"
                label="Nama Lengkap"
                name="fullname"
                autoComplete="fullname"
                onChange={e => setFullname(e.target.value)}
                value={fullname}
                size="small"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                required
                fullWidth
                id="email"
                label="Email"
                name="email"
                autoComplete="email"
                onChange={e => setEmail(e.target.value)}
                value={email}
                size="small"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                required
                fullWidth
                id="phonenumber"
                label="No. Whatsapp (WA)"
                name="phonenumber"
                autoComplete="phonenumber"
                onChange={e => setPhonenumber(e.target.value)}
                value={phonenumber}
                size="small"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                required
                fullWidth
                id="zoom"
                label="Username Zoom"
                name="zoom"
                autoComplete="zoom"
                onChange={e => setZoom(e.target.value)}
                value={zoom}
                size="small"
              />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body2">
                <i><b>Note:</b> username zoom akan digunakan untuk acara Virtual Job Fair 2021 dan tidak bisa diubah.</i>
              </Typography>
            </Grid>
          </Grid>
          <Button
            type="button"
            fullWidth
            variant="contained"
            color="primary"
            size="large"
            className={classes.submit}
            onClick={async () => {
              let param = [fullname, email, phonenumber, zoom]
              let paramStr = ['Nama', 'Email', 'Nomor Telepon', 'Username Zoom']
              let empty = []
              for (let index = 0; index < param.length; index++) {
                const element = param[index];
                if (!element) {
                  empty.push(paramStr[index])
                }
              }

              if (empty.length !== 0) {
                return Swal.fire({
                  icon: 'error',
                  title: 'Masih belum di isi',
                  text: empty.join(' , '),
                })
              }

              let getParticipant = await axios.post(`${process.env.REACT_APP_API}/participant/check`, { email })
              if (getParticipant.data === "time off") {
                return Swal.fire({
                  icon: 'error',
                  title: 'Pendaftaran sudah di tutup',
                })
              }
              let dataPayment = ''

              if (event === 'FREE') {
                let getPaymentPackage = await axios.get(`${process.env.REACT_APP_API}/participant/free/payment/package`)
                console.log('get participant', getPaymentPackage)
                return onSubmit(fullname, email, phonenumber, zoom, getPaymentPackage.data.id , getParticipant.data, dataPayment, history)
              }

              if (getParticipant.data !== '') {
                let getPayment = await axios.post(`${process.env.REACT_APP_API}/participant/payment/check`, { participant_id: getParticipant.data.id })
                return Swal.fire({
                  title: 'Datamu sudah ada ?',
                  showCancelButton: true,
                  confirmButtonText: `Lanjut`,
                  denyButtonText: `Batal`,
                }).then((result) => {
                  if (result.isConfirmed) {
                    return history.push({
                      pathname: '/register/package',
                      state: {
                        name: fullname,
                        email,
                        no_wa: phonenumber,
                        zoom_user: zoom,
                        getParticipant: getParticipant.data,
                        getPayment: getPayment.data
                      }
                    })
                  }
                })
              }

              history.push({
                pathname: '/register/package',
                state: {
                  name: fullname,
                  email,
                  no_wa: phonenumber,
                  zoom_user: zoom,
                  getParticipant: getParticipant.data,
                  getPayment: dataPayment
                }
              })
            }}
          >
            DAFTAR
          </Button>
        </form>
      </div>
      <Box mt={0} mb={5}>
        <p style={{ textAlign: "center" }}>Sudah punya Nomor Registrasi? <a href="/participant/participant/login" style={{ fontWeight: 600 }}>Masuk</a></p>
        <Copyright />
      </Box>
    </Container>
  );
}